import { Heart, MapPin } from "lucide-react";
import { GradeStrip } from "@/components/browse/GradeStrip";
import { ForYouTag, OC } from "@/components/onboarding/onboardingUi";
import type { PickGrades } from "../../../supabase/functions/_shared/picksRanking.ts";

/** Score seal used on the onboarding café cards. */
export function ScoreSeal({ score }: { score: number | null }) {
  return (
    <div
      className="relative h-12 w-12 shrink-0 rounded-full flex flex-col items-center justify-center"
      style={{ backgroundColor: "#FDF8F0", border: "1.5px solid #C4A882" }}
      aria-label={score != null ? `Grounded Score ${score}` : "Grounded Score"}
    >
      <span style={{ fontSize: 5.5, letterSpacing: "0.16em", color: OC.muted, textTransform: "uppercase" }}>Grounded</span>
      <span style={{ fontSize: 17, fontWeight: 700, color: "#3B2314", lineHeight: 1 }}>{score ?? "–"}</span>
      <span style={{ fontSize: 5.5, letterSpacing: "0.16em", color: OC.muted, textTransform: "uppercase" }}>Score</span>
    </div>
  );
}

export function PickCard({
  name,
  area,
  score,
  grades,
  forYou = false,
  saved,
  onToggle,
  subline,
}: {
  name: string;
  area: string | null;
  score: number | null;
  grades?: PickGrades | null;
  forYou?: boolean;
  saved: boolean;
  onToggle?: () => void;
  subline?: string;
}) {
  return (
    <div
      className="w-full rounded-2xl p-3.5"
      style={{ backgroundColor: OC.white, border: `0.5px solid #E4DACA`, boxShadow: "0 4px 14px rgba(44,24,16,0.05)" }}
      data-testid="pick-card"
    >
      <div className="flex items-center gap-3">
        <ScoreSeal score={score} />
        <div className="flex-1 min-w-0">
          <div className="truncate" style={{ fontSize: 15, fontWeight: 600, color: OC.text }}>{name}</div>
          <div className="flex items-center gap-1.5 mt-0.5 min-w-0" style={{ fontSize: 12, color: OC.textSec }}>
            {subline ? (
              <>
                <span>{subline}</span>
                {forYou && <ForYouTag />}
              </>
            ) : (
              <>
                {area && <MapPin size={12} className="shrink-0" />}
                {area && <span className="truncate">{area}</span>}
                {forYou && <ForYouTag />}
              </>
            )}
          </div>
        </div>
        {onToggle ? (
          <button
            onClick={onToggle}
            aria-label={saved ? `Remove ${name} from saved` : `Save ${name}`}
            aria-pressed={saved}
            className="w-12 flex flex-col items-center justify-center gap-0.5 shrink-0"
            style={{ color: saved ? "#C23B3B" : "#9A7B5F", fontSize: 10.5, fontWeight: 600, letterSpacing: "0.02em" }}
          >
            <Heart size={26} strokeWidth={2.2} color="#D64545" fill={saved ? "#D64545" : "#FFF4F2"} />
            {saved ? "Saved" : "Save"}
          </button>
        ) : (
          <Heart size={22} color="#D64545" fill="#D64545" className="shrink-0" aria-hidden="true" />
        )}
      </div>
      <GradeStrip grades={grades ?? {}} className="mt-3" />
    </div>
  );
}
